module.exports = __webpack_public_path__ + "static/img/business70.87485cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business70.png
// module id = k6jB
// module chunks = 9